// TruVelox Theme JS v1.0

document.addEventListener('DOMContentLoaded', () => {

  // Reveal on scroll
  const reveals = document.querySelectorAll('.reveal');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 60);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  reveals.forEach(r => io.observe(r));

  // Cart notification
  document.querySelectorAll('.pcard-btn, .add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const variantId = this.dataset.variantId;
      if (variantId) {
        e.preventDefault();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(r => r.json())
        .then(data => {
          showCartNotification(data.title);
          updateCartCount();
        })
        .catch(() => window.location.href = '/collections/all');
      }
    });
  });

  function showCartNotification(title) {
    let notif = document.querySelector('.cart-notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.className = 'cart-notification';
      document.body.appendChild(notif);
    }
    notif.textContent = `✓ ${title} added to cart`;
    notif.classList.add('show');
    setTimeout(() => notif.classList.remove('show'), 3000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = document.querySelector('.cart-count');
        if (count) count.textContent = cart.item_count;
      });
  }

  // Initialize cart count
  updateCartCount();

  // PWA install button
  const installBtn = document.getElementById('pwaInstallBtn');
  const iosTip = document.getElementById('pwaIosTip');
  const iosTipClose = document.getElementById('pwaIosTipClose');

  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true;

  if (installBtn && !isStandalone) {
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent)
      && !window.MSStream;

    let deferredPrompt = null;

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;
      installBtn.hidden = false;
    });

    if (isIos) {
      // iOS has no beforeinstallprompt — show the button and explain the
      // manual Share > Add to Home Screen flow instead.
      installBtn.hidden = false;
    }

    installBtn.addEventListener('click', async () => {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
        deferredPrompt = null;
        installBtn.hidden = true;
        return;
      }
      if (isIos && iosTip) {
        iosTip.hidden = false;
      }
    });

    window.addEventListener('appinstalled', () => {
      installBtn.hidden = true;
      deferredPrompt = null;
    });

    if (iosTipClose) {
      iosTipClose.addEventListener('click', () => {
        iosTip.hidden = true;
      });
    }
  }

});
